<template>
    <el-popover
        :disabled="isShow"
        :append-to-body="true"
        placement="top-end"
        popper-class="pop_cart"
        width="620"
        trigger="hover"
    >
        <p><span>购物车</span><i class="el-icon-close" @click="handleClose"></i></p>
        <el-table :data="list" :show-header="false" row-class-name="cart_row">
            <el-table-column width="300" label="商品">
                <template slot-scope="scope">
                    <div class="cart_table_name">
                        <img :src="host + '/' + scope.row.goods_thumb" alt="">
                        <span style="text-align: left">
                            {{scope.row.goods_name}}
                            <pre style="font-size: 12px;margin: 0; line-height: 1.5">{{scope.row.goods_attr}}</pre>
                        </span>
                    </div>
                </template>
            </el-table-column>
            <el-table-column width="100" label="金额" prop="goods_price_no">
                <template slot-scope="scope">
                    <span style="color: #f74845">
                        ￥{{(Number(scope.row.goods_price_no) * scope.row.goods_number).toFixed(2)}}
                    </span>
                </template>
            </el-table-column>
            <el-table-column width="200" label="数量">
                <template slot-scope="scope">
                    <div>
                        <el-input-number
                            @change="(val) => handleChange(val, scope.row)"
                            v-model="scope.row.goods_number"
                            size="mini"
                            :min="0"
                            :max="Number(scope.row.sale_of_goods_inventory)"
                        ></el-input-number>
                        <span> 库存{{scope.row.sale_of_goods_inventory}}件</span>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <slot slot="reference"></slot>
    </el-popover>
</template>

<script>
    import { host, setCartProducts } from '../../stores/api';

    export default {
        props: ['list'],
        data () {
            return {
                host: host,
                isShow: false, //关闭按钮
            };
        },
        methods: {
            handleChange (val, params) {
                const {rec_id} = params;
                setCartProducts(rec_id, val);
            },
            handleClose () {
                this.isShow = true;
                setTimeout(() => {
                    this.isShow = false;
                }, 500);
            }
        }
    };
</script>
<style lang="less">
    .pop_cart {
        /*width: 600PX;*/
        padding: 0;
        & > p {
            margin: 0;
            background: #f0f1f2;
            padding: 5px 16px;
            font-size: 12px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            & > i {
                cursor: pointer;
                &:hover {
                    color: red;
                }
            }
        }
        .el-table {
            max-height: 400PX;
            overflow-y: auto;
            overflow-x: hidden;
        }
        .cart_row {
            td {
                font-size: 14px;
                vertical-align: top;
                .cart_table_name {
                    display: flex;
                    img {
                        width: 60PX;
                        height: 60PX;
                        margin: 0 6px;
                    }
                }
                .el-input-number--mini {
                    width: 100PX;
                }
            }

        }

    }
</style>



// WEBPACK FOOTER //
// src/components/AddPro/Cart.vue